import authReducers, {
  STATE_KEY as AUTH_STATE_KEY,
} from 'reducers/authReducers'

import entityReducers, {
  STATE_KEY as ENTITY_STATE_KEY,
} from 'reducers/entityReducers'

import appStatusReducers, {
  STATE_KEY as APP_STATUS_STATE_KEY,
} from 'reducers/appStatusReducers'

import inventoryReducers, {
  STATE_KEY as DASHBOARD_STATE_KEY,
} from 'reducers/inventoryReducers'

import quoteReducers, {
  STATE_KEY as QUOTE_STATE_KEY,
} from 'reducers/quoteReducers'

import naughtyReducers, {
  STATE_KEY as NAUGHTY_STATE_KEY,
} from 'reducers/naughtyReducers'

import loyaltyDashboardReducers, {
  STATE_KEY as LOYALTY_STATE_KEY,
} from 'reducers/loyaltyDashboardReducers'

import customerDetailsReducers, {
  STATE_KEY as CUSTOMER_DETAILS_STATE_KEY,
} from 'reducers/customerDetailsReducers'

import customerHistoryReducers, {
  STATE_KEY as CUSTOMER_HISTORY_STATE_KEY,
} from 'reducers/customerHistoryReducers'

import customerListingReducers, {
  STATE_KEY as CUSTOMER_LISTING_STATE_KEY,
} from 'reducers/customerListingReducers'

import engagementDashboardReducers, {
  STATE_KEY as ENGAGEMENT_STATE_KEY,
} from 'reducers/engagementDashboardReducers'

import roseyReducers, {
  STATE_KEY as ROSEY_STATE_KEY,
} from 'reducers/roseyReducers'

import presenterReducers, {
  STATE_KEY as PRESENTER_STATE_KEY,
} from 'reducers/presenterReducers'

// wire this up

const reducers = {
  [AUTH_STATE_KEY]: authReducers,
  [ENTITY_STATE_KEY]: entityReducers,
  [APP_STATUS_STATE_KEY]: appStatusReducers,
  [DASHBOARD_STATE_KEY]: inventoryReducers,
  [QUOTE_STATE_KEY]: quoteReducers,
  [NAUGHTY_STATE_KEY]: naughtyReducers,
  [LOYALTY_STATE_KEY]: loyaltyDashboardReducers,
  [CUSTOMER_DETAILS_STATE_KEY]: customerDetailsReducers,
  [CUSTOMER_HISTORY_STATE_KEY]: customerHistoryReducers,
  [CUSTOMER_LISTING_STATE_KEY]: customerListingReducers,
  [ENGAGEMENT_STATE_KEY]: engagementDashboardReducers,
  [ROSEY_STATE_KEY]: roseyReducers,
  [PRESENTER_STATE_KEY]: presenterReducers,
}

export default reducers
